import React from "react";
import { selectedIndexTickerState } from "@states/indexGlobal";
import { useRecoilValue } from "recoil";
import IndexPanel from "./Panel/IndexPanel";
import AnalysisPanel from "./Panel/AnalysisPanel";
import { TabContents } from "@components/tab/TabPanel";

const Contents = [
  {
    label: "가상 지수",
    component: <IndexPanel />,
  },
  {
    label: "분석",
    component: <AnalysisPanel />,
  },
];

function EtfTabs() {
  const selectedIndexTicker = useRecoilValue(selectedIndexTickerState);
  return (
    <>
      {selectedIndexTicker && (
        <TabContents tabs={Contents} />
        )}
    </>
  );
}

export default EtfTabs;
